import styled from "styled-components"

export const StyledWorksWrapper = styled.div`
  flex-basis: 280px;
  margin-bottom: 20px;
  margin: 30px 10px;

  cursor: pointer;
  transition: 0.25s transform ease-in-out;
  &:hover {
    transform: scale(1.05);
  }
  img {
    border: solid 2px #001c31;
    width: 280px;
    height: 180px;
  }
`

export const WorksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 60px;
`

export const WorksTitle = styled.div`
  font-size: 12px;
`
